<app-modal [modalId]="id" title="Approve User">
    <div class="filtercard">
        <p> Are you sure you want to approve this user?</p>
        <div class="common_btn">
            <button id="btn-cancel-unapprove" data-dismiss="modal">Cancel</button>
            <button class="btn-submit" (click)="approve()">Yes</button>
        </div>
    </div>
</app-modal>